import { faMegaphoneShout } from './custom-icons/fa-megaphone-shout.icon';

export const fac = {
  [faMegaphoneShout.iconName]: faMegaphoneShout,
};
